import { render, staticRenderFns } from "./ShareDashboard.vue?vue&type=template&id=0b5a89cd&scoped=true&"
import script from "./ShareDashboard.vue?vue&type=script&lang=js&"
export * from "./ShareDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ShareDashboard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShareDashboard.vue?vue&type=style&index=1&id=0b5a89cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5a89cd",
  null
  
)

export default component.exports